import { memo } from "react";
import { SnackbarItem } from "./snackbar-item";
import { useSnackbarStore } from "./snackbar.store";

export const SnackbarList = memo(() => {
	const messages = useSnackbarStore((s) => s.messages);

	return (
		<>
			{messages.map((m) => (
				<SnackbarItem key={m.id} {...m} />
			))}
		</>
	);
});
SnackbarList.displayName = "SnackbarList";
